module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "40px",
      "float": "left"
    },
    attrs: {
      "src": require("../static/img/logo-small.png"),
      "alt": "Printer Counters"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("V. " + _vm._s(_vm.$root.version))]), _vm._v(" "), (_vm.$root.hasNewVersion) ? _c('span', {
    staticClass: "label label-danger",
    on: {
      "click": function($event) {
        return _vm.$root.confirmRefresh()
      }
    }
  }, [_vm._v("1")]) : _vm._e()]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    class: ['sidebar-toggle topMenu', _vm.activeMenu === 'Dashboard' ? 'active' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Dashboard')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "14px"
    }
  }, [_vm._v("Dashboard")])]), _vm._v(" "), _c('a', {
    class: ['sidebar-toggle topMenu', (_vm.activeMenu === 'Printers' || _vm.activeMenu === 'Printer' || _vm.activeMenu === 'PrinterHistory') ? 'active' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Printers')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "14px"
    }
  }, [_vm._v("Printers")])]), _vm._v(" "), (0 > 1) ? _c('a', {
    class: ['sidebar-toggle topMenu', _vm.activeMenu === 'TonerHistory' ? 'active' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('TonerHistory')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tint"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "14px"
    }
  }, [_vm._v("Toner History")])]) : _vm._e(), _vm._v(" "), _c('a', {
    class: ['sidebar-toggle topMenu', _vm.activeMenu === 'History' ? 'active' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('History')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-history"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "14px"
    }
  }, [_vm._v("Printers History")])]), _vm._v(" "), _c('a', {
    class: ['sidebar-toggle topMenu', _vm.activeMenu === 'Reports' ? 'active' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "blur": function($event) {
        return _vm.testBlur('Reports')
      },
      "click": function($event) {
        return _vm.$root.goto('Reports')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "14px"
    }
  }, [_vm._v("Reports")])]), _vm._v(" "), (_vm.$root.isAdmin === 9999) ? _c('a', {
    class: ['sidebar-toggle topMenu', _vm.activeMenu === 'ReportDesigner' ? 'active' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('ReportDesigner')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paint-brush"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "14px"
    }
  }, [_vm._v("Designer")])]) : _vm._e(), _vm._v(" "), (_vm.$root.isAdmin) ? _c('a', {
    class: ['sidebar-toggle topMenu', _vm.activeMenu === 'Dealers' ? 'active' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Dealers')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-graduation-cap"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "14px"
    }
  }, [_vm._v("Dealers")])]) : _vm._e(), _vm._v(" "), (_vm.$root.isAdmin || _vm.$root.isDealer || _vm.$root.isDealerAssistance) ? _c('a', {
    class: ['sidebar-toggle topMenu', _vm.activeMenu === 'Customers' ? 'active' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Customers')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "14px"
    }
  }, [_vm._v("Customers")])]) : _vm._e(), _vm._v(" "), (_vm.$root.isAdmin || _vm.$root.isDealer || _vm.$root.isCustomer) ? _c('a', {
    class: ['sidebar-toggle topMenu', _vm.activeMenu === 'Sites' ? 'active' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Sites')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "14px"
    }
  }, [_vm._v("Sites")])]) : _vm._e(), _vm._v(" "), (_vm.$root.isAdmin || _vm.$root.isDealer || _vm.$root.isDealerAssistance) ? _c('a', {
    class: ['sidebar-toggle topMenu', _vm.activeMenu === 'Users' ? 'active' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Users')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "14px"
    }
  }, [_vm._v("Users")])]) : _vm._e(), _vm._v(" "), _c('a', {
    class: ['sidebar-toggle topMenu', _vm.activeMenu === 'Alerts' ? 'active' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Alerts')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "14px"
    }
  }, [_vm._v("Alerts")])]), _vm._v(" "), (_vm.$root.isAdmin || _vm.$root.isDealer || _vm.$root.isDealerAssistance) ? _c('a', {
    class: ['sidebar-toggle topMenu', _vm.activeMenu === 'Updates' ? 'active' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Updates')
      }
    }
  }, [(_vm.$root.isAdmin) ? _c('i', {
    staticClass: "fa fa-upload"
  }) : _c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "14px"
    }
  }, [_vm._v("Updates")])]) : _vm._e(), _vm._v(" "), (_vm.$root.isAdmin) ? _c('a', {
    class: ['sidebar-toggle topMenu', _vm.activeMenu === 'Inbox' ? 'active' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Inbox')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-inbox"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "14px"
    }
  }, [_vm._v("Inbox")])]) : _vm._e(), _vm._v(" "), _c('a', {
    class: ['sidebar-toggle topMenu', _vm.activeMenu === 'Contactus' ? 'active' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Contactus')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sticky-note-o"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "14px"
    }
  }, [_vm._v("Contact Us")])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.alertsCount > 0) ? _c('li', {
    attrs: {
      "title": "Your Email address is NOT Verified !"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "data-toggle": "control-sidebar"
    },
    on: {
      "click": function($event) {
        return _vm.showAlert('Your Email address is NOT Verified !')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.alertsCount))])])]) : _vm._e(), _vm._v(" "), (0 > 1) ? _c('li', {
    class: [_vm.activeMenu === 'Settings' ? 'active' : ''],
    attrs: {
      "title": "Settings"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "data-toggle": "control-sidebar"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Settings')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    class: ['dropdown-toggle', _vm.activeMenu === 'Account' ? 'active' : ''],
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$root.userFullName))]), _vm._v(" "), _c('img', {
    staticClass: "user-image roundImage",
    attrs: {
      "src": _vm.logoPath,
      "alt": "User Image"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.logoPath,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$root.userFullName))])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Account')
      }
    }
  }, [_vm._v("Profile")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.$root.logout
    }
  }, [_vm._v("Sign out")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "id": "btnSidebarToggle",
      "href": "#",
      "data-toggle": "push-menu",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-af100d02!./~/vue-loader/lib/selector.js?type=template&index=0!./src/NaviBar.vue
// module id = 747
// module chunks = 0